import { Badge, type BadgeProps, Box } from "@biom3/react";

export function MultiLine({
  lines,
  testId,
}: {
  lines: string[] | undefined;
  testId: string;
}) {
  return (
    <>
      {lines?.length
        ? lines.map((line, index) => (
            <Box key={`quest-line-${line}`} testId={`${testId}-${index}`}>
              {line}
            </Box>
          ))
        : null}
    </>
  );
}

export function MultiLineWithBadge({
  lines,
  testId,
  badgeProps,
}: {
  lines: string[] | undefined;
  testId: string;
  badgeProps: BadgeProps[] | null;
}) {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: "base.spacing.x2" }}>
      {badgeProps?.map((badge, badgeIndex) => (
        <Badge
          key={`${testId}-badge-${badge.badgeContent}`}
          testId={`${testId}-badge-${badgeIndex}`}
          {...badge}
        />
      ))}

      {lines?.map((line, index) => (
        <Badge
          key={`quest-line-badge-${line}`}
          testId={`${testId}-${index}`}
          badgeContent={line}
          variant="light"
        />
      ))}
    </Box>
  );
}
